import './style.scss'
import { useEffect, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { windowResize } from '../../redux/reducers/resizeSlice';
import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HeaderLandingPage from '../../sections/header/HeaderLandingPage';

function LandingPage() {
	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)
	const dispatch = useAppDispatch()

	const [optionExpanded0, setOptionExpanded0] = useState<boolean>(false)
	const [optionExpanded1, setOptionExpanded1] = useState<boolean>(false)
	const [optionExpanded2, setOptionExpanded2] = useState<boolean>(false)
	const [optionExpanded3, setOptionExpanded3] = useState<boolean>(false)
	const [optionExpanded4, setOptionExpanded4] = useState<boolean>(false)
	const [optionExpanded5, setOptionExpanded5] = useState<boolean>(false)

	useEffect(() => {
		initializeSite()
	})

	// Called on initial page load and used to prepare the site
	const initializeSite = () => {
		addResizeHandler()
	}

	const addResizeHandler = () => {
		window.addEventListener('resize', () => {
			dispatch(windowResize())
		})
		dispatch(windowResize())
	}

	// const option0Style = useMemo(
	// 	() => ({
	// 		maxHeight: innerWidth > 650 || optionExpanded0 ? '350px' : 0
	// 	}),
	// 	[optionExpanded0, innerWidth] // , mouseDown, calculatePercentage]
	// )
	// const option1Style = useMemo(
	// 	() => ({
	// 		maxHeight: innerWidth > 650 || optionExpanded1 ? '350px' : 0
	// 	}),
	// 	[optionExpanded1, innerWidth]
	// )
	// const option1Style = useMemo(
	// 	() => ({
	// 		maxHeight: innerWidth > 650 || optionExpanded1 ? '350px' : 0
	// 	}),
	// 	[optionExpanded1, innerWidth]
	// )
	// const option1Style = useMemo(
	// 	() => ({
	// 		maxHeight: innerWidth > 650 || optionExpanded1 ? '350px' : 0
	// 	}),
	// 	[optionExpanded1, innerWidth]
	// )
	// const option1Style = useMemo(
	// 	() => ({
	// 		maxHeight: innerWidth > 650 || optionExpanded1 ? '350px' : 0
	// 	}),
	// 	[optionExpanded1, innerWidth]
	// )

	return (
		<>
			<div className='section-wrap min-h-fit-section-wrap'>
				<div className='home-page-hero'>
					<div className='section-wrap home-page-header'>
						<HeaderLandingPage />
					</div>
					<div className='home-page-hero-content'>
						<div className='home-page-hero-tag-header'>Progress is easier, when<br/>feedback is <span className='home-page-hero-tag-span-alt-colour'>personalized.</span></div>
						<div className='home-page-hero-sub-text'>The method is simple: choose your instructor, upload your clips, and receive tailored feedback - all within 24 hours.</div>
						<img 
							className='home-page-hero-profile-pics'
							src='/imgs/home/hero-profiles.png'
							alt='Hero Profiles'
							aria-label='Hero section profile'
						/>
						<div className='home-page-hero-button-wrap'>
							<a
								href={PAGE_URLS.SIGN_UP}
								className='home-page-hero-button'
								aria-label='Link to sign up page'
							>
								Sign Up
							</a>
							<a
								href={PAGE_URLS.SEARCH}
								className='home-page-hero-button home-page-hero-button-alt'
								aria-label='Link to search page'
							>
								Browse Instructors
							</a>
						</div>
						<div className='home-page-hero-tag-line'>First Session Free!<br/>No Risk, Full Reward.</div>
					</div>
					{/* <div className='home-page-hero-tag-line'>First Session Free!<br/>No Risk, Full Reward.</div> */}
				</div>
			</div>
			{innerWidth > 650 &&
				<div className='section-wrap d-f'>
					<div className='did-you-know-section'>
						<div className='did-you-know-title'>
							Did you know?
						</div>
						<div className='did-you-know-text'>
							Roughly <span className='darker-text'>65%</span> of people are visual learners - that's why skiers and snowboarders are choosing SkiVio for video-based feedback.
						</div>
					</div>
				</div>
			}
			<div className='section-wrap min-h-fit-section-wrap d-f'>
				<div className='section-content home-page-section-content'>
					<div className='home-page-title-text'>It's Frustrating,<br/><span className='home-page-hero-title-span'>We've been there.</span></div>
					<div className='home-page-sub-text'>Random online ski videos can only take you so far. With Skivio, you choose the right instructor and get feedback tailored just for you.</div>
					{innerWidth < 651 ?
						<LazyLoadImage
							className='home-page-content-card-img'
							// src={'/imgs/home/home-messages.svg'}
							src={'/imgs/home/home-messages.png'}
							alt='Messages'
						/>
						:
						<LazyLoadImage
							className='home-page-buubles-desktop-img'
							src={'/imgs/home/bubbles-desktop.svg'}
							alt='Messages'
						/>
						// <div className='bubble-wrap'>
						// 	<LazyLoadImage
						// 		className='bubble bubble0'
						// 		src={'/imgs/home/bubble-1.svg'}
						// 		alt='Bubble Message'
						// 	/>
						// 	<LazyLoadImage
						// 		className='bubble bubble1'
						// 		src={'/imgs/home/bubble-0.svg'}
						// 		alt='Bubble Message'
						// 	/>
						// 	<LazyLoadImage
						// 		className='bubble bubble2'
						// 		src={'/imgs/home/bubble-2.svg'}
						// 		alt='Bubble Message'
						// 	/>
						// </div>
					}
				</div>
			</div>
			<div className='section-wrap min-h-fit-section-wrap d-f'>
				<div className='section-content home-page-section-content'>
					<div className='home-page-title-text'>There's a <span className='home-page-hero-title-span-alt'>smarter</span> choice.<br/>Level up your skiing.</div>
					<div className='home-choice-list-wrap'>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded0(optionExpanded0 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-0.png'}
									alt='Choose Instructor'
								/>
								{innerWidth < 651 ?
									<>
										<div className='home-choice-title'>
											Certified Instructors
										</div>
										<LazyLoadImage
											// className='home-choice-drop-arrow'
											className={optionExpanded0 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
											// style={useMemo(
											// 	() => ({
											// 		transform: optionExpanded0 ? 'rotation(0deg)' : 'rotation(90deg)'
											// 	}),
											// 	[optionExpanded0]
											// )}
											src={'/imgs/home/arrow_drop_down.png'}
											alt='Drow down arrow'
										/>
									</>
									:
									<div className='home-choice-title'>
										Certified<br/>Instructors
									</div>
								}
							</div>
							<div 
								// className={innerWidth > 650 || optionExpanded0 ? 'home-choice-caption home-choice-caption-not-hidden' : 'home-choice-caption'}
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded0 ? '350px' : 0
									}),
									[optionExpanded0, innerWidth] // , mouseDown, calculatePercentage]
								)}
							>
								Work with some of the best instructors on the slopes - all reviewed and verified by SkiVio.
							</div>
						</div>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded1(optionExpanded1 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-1.png'}
									alt='Choose Feedback'
								/>
								{innerWidth < 651 ?
									<>
										<div className='home-choice-title'>
											Personalised Feedback
										</div>
										<LazyLoadImage
											className={optionExpanded1 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
											src={'/imgs/home/arrow_drop_down.png'}
											alt='Drow down arrow'
										/>
									</>
									:
									<div className='home-choice-title'>
										Personalised<br/>Feedback
									</div>
								}
							</div>
							{/* <div className='home-choice-caption'>
								Share your goals, track your runs, highlight injuries or obstacles, and get tailored feedback made just for you.
							</div> */}
							{/* {(innerWidth > 650 || optionExpanded1) &&
								<div className='home-choice-caption'>
									Share your goals, track your runs, highlight injuries or obstacles, and get tailored feedback made just for you.
								</div>
							} */}
							{/* <div className={innerWidth > 650 || optionExpanded1 ? 'home-choice-caption home-choice-caption-not-hidden' : 'home-choice-caption'}>
								Share your goals, track your runs, highlight injuries or obstacles, and get tailored feedback made just for you.
							</div> */}
							<div 
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded1 ? '350px' : 0
									}),
									[optionExpanded1, innerWidth]
								)}
							>
								Share your goals, track your runs, highlight injuries or obstacles, and get tailored feedback made just for you.
							</div>
						</div>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded2(optionExpanded2 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-2.png'}
									alt='Choose Turn around'
								/>
								{innerWidth < 651 ?
									<>
										<div className='home-choice-title'>
											Fast Turnaround
										</div>
										<LazyLoadImage
											className={optionExpanded2 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
											src={'/imgs/home/arrow_drop_down.png'}
											alt='Drow down arrow'
										/>
									</>
									:
									<div className='home-choice-title'>
										Fast<br/>Turnaround
									</div>
								}
							</div>
							{/* <div className='home-choice-caption'>
								You will receive your feedback in under 24 hours. 100% Money Back Guarantee.
							</div> */}
							{/* {(innerWidth > 650 || optionExpanded2) &&
								<div className='home-choice-caption'>
									You will receive your feedback in under 24 hours. 100% Money Back Guarantee.
								</div>
							} */}
							<div 
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded2 ? '350px' : 0
									}),
									[optionExpanded2, innerWidth]
								)}
							>
								You will receive your feedback in under 24 hours. 100% Money Back Guarantee.
							</div>
						</div>
					</div>
					<div className='home-choice-list-wrap'>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded3(optionExpanded3 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-3.png'}
									alt='Choose Revisit'
								/>
								<div className='home-choice-title'>
									Simply Revisit
								</div>
								{innerWidth < 651 &&
									<LazyLoadImage
										className={optionExpanded3 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
										src={'/imgs/home/arrow_drop_down.png'}
										alt='Drow down arrow'
									/>
								}
							</div>
							{/* <div className='home-choice-caption'>
								All your sessions will be stored in your personal dashboard so you can review at any time.
							</div> */}
							{/* {(innerWidth > 650 || optionExpanded3) &&
								<div className='home-choice-caption'>
									All your sessions will be stored in your personal dashboard so you can review at any time.
								</div>
							} */}
							<div 
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded3 ? '350px' : 0
									}),
									[optionExpanded3, innerWidth]
								)}
							>
								All your sessions will be stored in your personal dashboard so you can review at any time.
							</div>
						</div>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded4(optionExpanded4 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-4.png'}
									alt='Choose Choose'
								/>
								<div className='home-choice-title'>
									Your Choice
								</div>
								{innerWidth < 651 &&
									<LazyLoadImage
										className={optionExpanded4 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
										src={'/imgs/home/arrow_drop_down.png'}
										alt='Drow down arrow'
									/>
								}
							</div>
							{/* <div className='home-choice-caption'>
								You can use our extensive filters, such as Age, Gender or Language, to find the perfect instructor for you.
							</div> */}
							{/* {(innerWidth > 650 || optionExpanded4) &&
								<div className='home-choice-caption'>
									You can use our extensive filters, such as Age, Gender or Language, to find the perfect instructor for you.
								</div>
							} */}
							<div 
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded4 ? '350px' : 0
									}),
									[optionExpanded4, innerWidth]
								)}
							>
								You can use our extensive filters, such as Age, Gender or Language, to find the perfect instructor for you.
							</div>
						</div>
						<div className='home-choice-item'>
							<div 
								className='home-choice-item-header'
								onClick={() => {
									setOptionExpanded5(optionExpanded5 == false)
								}}
							>
								<LazyLoadImage
									className='home-choice-icon'
									src={'/imgs/home/icon-5.png'}
									alt='Choose Proven'
								/>
								<div className='home-choice-title'>
									Proven Approach
								</div>
								{innerWidth < 651 &&
									<LazyLoadImage
										className={optionExpanded5 ? 'home-choice-drop-arrow' : 'home-choice-drop-arrow home-choice-drop-arrow-rotated'}
										src={'/imgs/home/arrow_drop_down.png'}
										alt='Drow down arrow'
									/>
								}
							</div>
							{/* <div className='home-choice-caption'>
								Based on science-backed techniques that statistically help you improve on the slopes.
							</div> */}
							{/* {(innerWidth > 650 || optionExpanded5) &&
								<div className='home-choice-caption'>
									Based on science-backed techniques that statistically help you improve on the slopes.
								</div>
							} */}
							<div 
								className='home-choice-caption'
								style={useMemo(
									() => ({
										maxHeight: innerWidth > 650 || optionExpanded5 ? '350px' : 0
									}),
									[optionExpanded5, innerWidth]
								)}
							>
								Based on science-backed techniques that statistically help you improve on the slopes.
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap d-f'>
				<div className='bottom-wide-img-wrap extra-t-m'>
					<LazyLoadImage
						className='bottom-wide-img'
						src={innerWidth < 601 ? '/imgs/home/home-bottom-wide-img-mobile.svg' : '/imgs/home/home-bottom-wide-img-desktop.svg'}
						alt='Caption'
					/>
				</div>
			</div>
			<div className='section-wrap min-h-fit-section-wrap d-f'>
				<div className='section-content home-page-section-content'>
					<div className='home-page-title-text choose-from-text'>Choose from a selection of<br/><span className='home-page-hero-title-span'>World Class Instructors</span></div>
					<div className='home-page-sub-text choose-from-sub-text'>Use our custom filters to find your perfect instructor. All instructors are fully verified by SkiVio. </div>
					<LazyLoadImage
						className='home-page-content-card-img'
						src={innerWidth < 601 ? '/imgs/home/screen-shot-mobile.png' : '/imgs/home/screen-shot-desktop.png'}
						alt='Search Screenshot'
					/>
					<div className='home-page-hero-button-wrap'>
						<a
							href={PAGE_URLS.SEARCH}
							className='home-page-hero-button home-page-hero-button-alt'
							aria-label='Link to search page'
						>
							Browse Instructors
						</a>
					</div>
				</div>
			</div>
			<div className='section-wrap d-f'>
				<div className='section-content home-page-section-content home-page-section-content-no-min-h'>
					<div className='home-page-gradient-title-text'>Progress<br/>One frame at a time.</div>
					<div className='d-f home-last-cta'>
						<div className='home-bottom-cta-sub-text'>Connecting you with <span className='home-page-hero-tag-span-alt-colour'>certified</span> instructors for personalized, affordable online video analysis.</div>
						<div className='home-page-hero-button-wrap'>
							<a
								href={PAGE_URLS.SIGN_UP}
								className='home-page-hero-button home-page-bottom-cta-button'
								aria-label='Link to sign up page'
							>
								Sign Up
							</a>
							<a
								href={PAGE_URLS.SEARCH}
								className='home-page-hero-button home-page-bottom-cta-button home-page-hero-button-alt'
								aria-label='Link to search page'
							>
								Browse Instructors
							</a>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default LandingPage
